// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.trend-table {
  font-variant-numeric: tabular-nums;
}

.trend-table--record {
  display: flex;
  flex-wrap: wrap;
}


.trend-table--header,
.trend-table--title,
.trend-table--label,
.trend-table--data
{
  padding: 8px
}

.trend-table--header {
  display: none;
}

.trend-table--title {
  width: 100%;
  border-bottom: 2px solid black;
  font-weight: 600;
}

.trend-table--label,
.trend-table--data {
  width: 50%;
}

.trend-table--label {
  font-weight: 600;
}

.trend-table--data {
  display: flex;
}

.trend-table--rate,
.trend-table--ci {
  width: -moz-fit-content;
  width: fit-content;
}

.trend-table--rate {
  margin-right: 16px;
}

.trend-table--smodd{
  background-color: #F4F4F7;
}

.trend-table svg {
  width: 32px;
  height: 24px;
}

.trend-table .span2 {
  grid-column: span 2;
}

span.trend-table--collapse {
  margin-left: 16px;
}

div.trend-table--collapse {
  display: none;
}

.trend-table--title:not(:nth-child(6)) {
  margin-top: 16px;
}


@media (min-width: 768px) {
  .trend-table--record {
    display: grid;
    grid-auto-columns: min-content;
    grid-template-columns: 3fr 1fr auto 1fr auto 1fr auto 1fr;
  }

  .trend-table--header {
    display: block;
    font-weight: bold;
    border-bottom: 2px solid black;
  }

  .trend-table--title {
    border-bottom: none;
    font-weight: normal;
  }

  .trend-table--label {
    display: none;
  }

  .trend-table--data {
    white-space: nowrap;
    width: 100%;
  }

  .trend-table--smodd {
    background-color: white;
  }

  .trend-table .trend-table--lgodd
  {
    background-color: #F4F4F7;
  }

  span.trend-table--collapse {
    display: none;
  }

  div.trend-table--collapse {
    display: block;
  }

  .trend-table--title:not(:nth-child(6)) {
    margin-top: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/uilib/accordion/trend-table.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;;AAGA;;;;;EAKE;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;;AAGA;EACE;IACE,aAAa;IACb,8BAA8B;IAC9B,yDAAyD;EAC3D;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".trend-table {\r\n  font-variant-numeric: tabular-nums;\r\n}\r\n\r\n.trend-table--record {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n\r\n.trend-table--header,\r\n.trend-table--title,\r\n.trend-table--label,\r\n.trend-table--data\r\n{\r\n  padding: 8px\r\n}\r\n\r\n.trend-table--header {\r\n  display: none;\r\n}\r\n\r\n.trend-table--title {\r\n  width: 100%;\r\n  border-bottom: 2px solid black;\r\n  font-weight: 600;\r\n}\r\n\r\n.trend-table--label,\r\n.trend-table--data {\r\n  width: 50%;\r\n}\r\n\r\n.trend-table--label {\r\n  font-weight: 600;\r\n}\r\n\r\n.trend-table--data {\r\n  display: flex;\r\n}\r\n\r\n.trend-table--rate,\r\n.trend-table--ci {\r\n  width: fit-content;\r\n}\r\n\r\n.trend-table--rate {\r\n  margin-right: 16px;\r\n}\r\n\r\n.trend-table--smodd{\r\n  background-color: #F4F4F7;\r\n}\r\n\r\n.trend-table svg {\r\n  width: 32px;\r\n  height: 24px;\r\n}\r\n\r\n.trend-table .span2 {\r\n  grid-column: span 2;\r\n}\r\n\r\nspan.trend-table--collapse {\r\n  margin-left: 16px;\r\n}\r\n\r\ndiv.trend-table--collapse {\r\n  display: none;\r\n}\r\n\r\n.trend-table--title:not(:nth-child(6)) {\r\n  margin-top: 16px;\r\n}\r\n\r\n\r\n@media (min-width: 768px) {\r\n  .trend-table--record {\r\n    display: grid;\r\n    grid-auto-columns: min-content;\r\n    grid-template-columns: 3fr 1fr auto 1fr auto 1fr auto 1fr;\r\n  }\r\n\r\n  .trend-table--header {\r\n    display: block;\r\n    font-weight: bold;\r\n    border-bottom: 2px solid black;\r\n  }\r\n\r\n  .trend-table--title {\r\n    border-bottom: none;\r\n    font-weight: normal;\r\n  }\r\n\r\n  .trend-table--label {\r\n    display: none;\r\n  }\r\n\r\n  .trend-table--data {\r\n    white-space: nowrap;\r\n    width: 100%;\r\n  }\r\n\r\n  .trend-table--smodd {\r\n    background-color: white;\r\n  }\r\n\r\n  .trend-table .trend-table--lgodd\r\n  {\r\n    background-color: #F4F4F7;\r\n  }\r\n\r\n  span.trend-table--collapse {\r\n    display: none;\r\n  }\r\n\r\n  div.trend-table--collapse {\r\n    display: block;\r\n  }\r\n\r\n  .trend-table--title:not(:nth-child(6)) {\r\n    margin-top: 0;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
